import * as Business from './business';
import * as User     from './user';
import Amplitude     from 'amplitude-js';
import buildInfo     from './app/build_info';
import decodeJWT     from './util/decode_jwt';
import onChange      from './util/on_change';
import rollbar       from './rollbar';
import store         from './store';


const amplitude = Amplitude.getInstance();

const productionKey  = '9f781a0aa363c8d9e1d5e3d98b245d32';
const developmentKey = '833d785c8ab509604a54f05cf20aaba9';
const apiKey         = process.env.NODE_ENV === 'production' ? productionKey : developmentKey;

amplitude.init(apiKey);
document.addEventListener('deviceready', onDeviceReady, false);
onChange(store, User.getJWTToken, onNewJWTToken);


// Cordova - Use device UUID and build number
async function onDeviceReady() {
  const { device } = window;

  if (device && device.uuid)
    amplitude.setDeviceId(device.uuid);

  amplitude.options.platform = 'Cordova';

  try {
    const { version } = buildInfo;
    if (version)
      amplitude.setVersionName(version);
  } catch (error) {
    rollbar.error(error);
  }
}


// Associate with user
function onNewJWTToken(_, jwtToken) {
  if (jwtToken) {
    const decoded = decodeJWT(jwtToken);
    amplitude.setUserId(decoded.sub);
    const name = decoded?.name;
    if (name)
      amplitude.setUserProperties({ name });
  } else
    amplitude.setUserId(null);
}


const logEvent = amplitude.logEvent;


amplitude.logEvent = function(eventType, eventProperties = {}, callback) {
  if (shouldLogEvents()) {
    const locationProperties = getLocationProperties();

    amplitude.setUserProperties(locationProperties);

    logEvent.call(this, eventType, expandProperties(eventProperties, locationProperties), callback);

    logPlanhatEvent(eventType);
  }
};


document.addEventListener('AmplitudeLogEvent', function(event) {
  const { eventType, eventProperties } = event.detail;
  amplitude.logEvent(eventType, eventProperties);
}, true);


function expandProperties(eventProperties, locationProperties) {
  return {
    url: document.location.href,
    ...locationProperties,
    ...eventProperties,
    ...getContactProperties(eventProperties),
  };
}


// Log events for active accounts.
// Also log events before we know the active account (e.g. sign in).
function shouldLogEvents() {
  const state        = store.getState();
  const isSalesforce = User.isSalesforce(state);

  if (isSalesforce)
    return false;

  const business = getCurrentBusiness();

  // No business until after sign in.
  if (business) {
    const isActive = (!business.status || business.status === 'active');
    return isActive;
  } else {
    // Do log all events before sign in.
    return true;
  }
}


// Users can switch locations, so location properties logged
// both as user and event properties.
function getLocationProperties() {
  const business = getCurrentBusiness();

  if (business) {
    return {
      businessID:   business.id,
      businessName: business.name,
      role:         getUserRole(business.id),
    };
  } else
    return {};
}


function getCurrentBusiness() {
  const state = store.getState();
  const id    = window.location.pathname.split('/')[1];

  if (id) {
    const name   = Business.getBusinessName(state, id);
    const status = Business.getBusinessStatus(state, id);

    return { id, name, status };
  } else
    return null;
}


function getUserRole(businessID) {
  const state = store.getState();
  return User.getRole(state, businessID);
}


function getContactProperties({ customer }) {
  if (customer) {
    return {
      customerID:         customer.id,
      customerLeadSource: customer.lead && customer.lead.source,
      customerStatus:     customer.status,
      customer:           undefined,
    };
  } else
    return {};
}

function logPlanhatEvent(action) {
  const businessID = window.location.pathname.split('/')[1];
  const state      = store.getState();
  const jwtToken   = User.getJWTToken(state);

  if (businessID && jwtToken) {
    const decoded = decodeJWT(jwtToken);
    const userID  = decoded.sub.replace('auth0|', '');
    const profile = User.getProfile(state);
    const name    = profile?.name;

    const requestOptions = {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action,
        name,
        externalId:        userID,
        companyExternalId: businessID,
      }),
      redirect: 'follow',
    };

    const planhatUUID = '33728570-6d67-4ce5-8c80-60607422ce4e';

    window.fetch(`https://analytics.planhat.com/analytics/${planhatUUID}`, requestOptions);
  }
}

export default amplitude;
